'use client';

import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
} from '@chakra-ui/react';
import { motion, MotionProps } from 'framer-motion';

export type IconButtonProps = ChakraIconButtonProps & MotionProps;

export const IconButton = (props: IconButtonProps) => {
  const { children, isDisabled = false, ...rest } = props;

  return (
    <ChakraIconButton
      as={motion.button}
      whileTap={isDisabled ? {} : { scale: 0.95 }}
      whileHover={isDisabled ? {} : { scale: 1.05 }}
      isDisabled={isDisabled}
      variant="icon"
      {...rest}
    >
      {children}
    </ChakraIconButton>
  );
};
